// Session AGZ: whether a list should render as a MOBILE CARD LIST instead of its desktop
// table, decided ONCE at mount.
//
// Why once-at-mount (the SchedulingPage day/week precedent) and not the PPM dual-render
// (both structures in the DOM, CSS-gated): the lists that use this helper expand IN PLACE
// to heavy stateful panels (ServiceRecordPanel and friends). Rendering the table AND the
// cards simultaneously would mount an open row's panel TWICE -- two unsynced React
// instances of the same record's edit state, where a viewport change mid-edit strands
// unsaved input in whichever instance just went display:none. Choosing exactly one layout
// at mount means the panel exists exactly once, and a phone rotating across the md
// boundary KEEPS its mounted layout (and any unsaved edits) instead of swapping it away.
//
// jsdom has no matchMedia, so every existing test renders the table -- the layout all the
// pinned queries (document-wide td probes, singular text lookups) were written against.
// A test that wants the card layout stubs matchMedia (the OfficeLayoutDrawer pattern).
export function initialMobileLayout(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(max-width: 767px)").matches
  );
}
